import React from 'react';
import I18n from 'i18n-react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import './SelectBoxPointsPlusMoney.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  optionsLabel: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.string),
  default: PropTypes.string,
  changeValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

const defaultProps = {
  label: '',
  required: false,
  errorMessage: '',
  placeholder: '',
  optionsLabel: [],
  values: [],
  default: null
};

class SelectBoxPointsPlusMoney extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      items: this.getItems(props),
      value: this.getDefaultValue(props)
    };
  }

  componentWillReceiveProps(nextProps) {       
    if (nextProps.default !== null) {      
      this.setState({
        value: I18n.translate(nextProps.default),
        items: this.getItems(nextProps)      
      });
    }
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  getDefaultValue(props) {
    return props.default ? I18n.translate(props.default) : undefined;
  }

  getItems(props) {     
    return props.values.map((value, index) => (
      <Select.Option
        key={value}
        id={`SelectBoxPointsPlusMoney-item-${this.props.id}-${index}`}
        className="SelectBoxPointsPlusMoney__selectItem">
        <a className={this.props.disabled?"SelectBoxPointsPlusMoney__selectLinkNotActive" : "SelectBoxPointsPlusMoney__selectLink"} id={`SelectBoxPointsPlusMoney-link-item-${this.props.id}-${index}`}>
          {props.optionsLabel[index]}
        </a>
      </Select.Option>
    ));
  }

  validateField = nextValue => {
    const isValid = !this.props.required || (this.props.required && nextValue);

    this.setState({
      isValidState: isValid,
      value: nextValue,
      invalidSelectionMessage: ''
    });

    this.props.changeValue(nextValue);

    return isValid;
  };

  renderLabel() {
    let label = <Row className="Field__label SelectBoxPointsPlusMoney__emptyLabel" />;

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_SelectBoxLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }

  renderField() {
    return (
      <Row>
        <Col className="SelectBox selectBoxPointsPlusMoney" xs={12}>
          <Select
            id={`${this.props.id}_SelectBoxPointsPlusMoneyId`}
            className={'SelectBoxPointsPlusMoney__select'
              }
            dropdownClassName="SelectBoxPointsPlusMoney__menu"
            defaultActiveFirstOption={false}
            onSelect={this.validateField}
            placeholder={I18n.translate(this.props.placeholder)}
            value={this.state.value}
            style={this.props.style || null}
            ref={ref => (this.input = ref)}
            disabled={this.props.disabled}            
          >
            {this.state.items}
          </Select>
        </Col>
      </Row>
    );
  }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}_SelectBoxPointsPlusMoneyFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_SelectBoxPointsPlusMoneyFooter`} xs={12}>
            <span className="Field__invalidField">
              {I18n.translate(this.state.invalidSelectionMessage || this.props.errorMessage)}
            </span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  render() {
    return (
      <div id={this.props.id} className="SelectBoxPointsPlusMoney Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

SelectBoxPointsPlusMoney.propTypes = propTypes;
SelectBoxPointsPlusMoney.defaultProps = defaultProps;

export default SelectBoxPointsPlusMoney;



// WEBPACK FOOTER //
// ./src/components/common/selectBoxPointsPlusMoney/SelectBoxPointsPlusMoney.jsx